import { render, staticRenderFns } from "./FolkeregisterConsent.vue?vue&type=template&id=28511f71&scoped=true&"
import script from "./FolkeregisterConsent.vue?vue&type=script&lang=js&"
export * from "./FolkeregisterConsent.vue?vue&type=script&lang=js&"
import style0 from "./FolkeregisterConsent.vue?vue&type=style&index=0&id=28511f71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28511f71",
  null
  
)

export default component.exports